export default __webpack_public_path__ + "1f418e5544d4d301c72b8efce2361b06.png";